'use client';

import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/components/ui/skeleton';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

import { useMyApplePayRegistrations } from '@/lib/api/apple-pay-registrations';
import { PlatformDefaultState } from './components/PlatformDefaultState';
import { RegistrationManager } from './components/RegistrationManager';

export default function ApplePaySettingsPage() {
  const { t } = useTranslation('settings');
  const { data, isLoading, error } = useMyApplePayRegistrations();
  const registration = data?.[0] ?? null;

  return (
    <div className="flex flex-col space-y-6">
      <div>
        <h2 className="text-xl font-bold tracking-tight">{t('applePay.pageTitle')}</h2>
        <p className="text-muted-foreground mt-1 text-sm">{t('applePay.pageDescription')}</p>
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Alert>
      )}

      {isLoading ? (
        <div className="space-y-3">
          <Skeleton className="h-28 w-full" />
          <Skeleton className="h-40 w-full" />
        </div>
      ) : registration ? (
        <RegistrationManager registration={registration} />
      ) : (
        <PlatformDefaultState />
      )}
    </div>
  );
}
